import { Auth } from 'aws-amplify';
import { setupAxiosInstance } from 'src/services/interceptor';
import { envConfigAction } from 'src/store/env';
import { store } from 'src/store';

interface IConfig {
  apiUrl: string;
  cognitoClientId: string;
  cognitoUserPoolId: string;
  fileUploadUrl: string;
}

const fetchAuthConfig = async (): Promise<IConfig> => {
  const url = '/console-config/env.json';
  const response = await fetch(url);
  const config = await response.json();
  return config;
};

const awsAuthConfigure = (config: IConfig): void => {
  Auth.configure({
    Auth: {
      region: 'eu-west-1',
      userPoolId: config.cognitoUserPoolId,
      userPoolWebClientId: config.cognitoClientId,
    },
  });
};

export const setupEnvironment = async (): Promise<void> => {
  return fetchAuthConfig().then((env) => {
    awsAuthConfigure(env);
    setupAxiosInstance(env.apiUrl);
    store.dispatch(envConfigAction({ data: env }));
    return;
  });
};
